import { Component, Inject } from '@angular/core';
import { AbstractControl, UntypedFormControl, UntypedFormGroup, ValidationErrors, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FIRST_ELEMENT_INDEX, IFormDelegate, IFormOptions } from '@modeso/aumico-lib-core-fe';
import { IAccountMappingSubFLI } from '@modeso/types__aumico-lib-annualreport-be';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'templates-duplicate-account-form',
    templateUrl: './duplicate-account-form.dialog.html',
    styleUrls: ['./duplicate-account-form.dialog.scss'],
})
export class DuplicateAccountFormDialogComponent {
    public options: IFormOptions;
    public formDelegate: IFormDelegate;
    public formGroup: UntypedFormGroup | undefined;

    constructor(
        public dialogRef: MatDialogRef<DuplicateAccountFormDialogComponent, IAccountMappingSubFLI[] | undefined>,

        @Inject(MAT_DIALOG_DATA) public data: IAccountMappingSubFLI[],
    ) {
        this.initializeForm();
    }

    private initializeForm(): void {
        this.formGroup = new UntypedFormGroup({
            ofThatItems: new UntypedFormControl(
                [this.data[FIRST_ELEMENT_INDEX]],
                [(control: AbstractControl): ValidationErrors | undefined => Validators.required(control)],
            ),
        });
    }

    public onSaveClicked(): void {
        this.dialogRef.close(this.formGroup?.get('ofThatItems')?.value);
    }

    public closeDialog(): void {
        this.dialogRef.close();
    }
}
